/** Copy do login/cadastro. PT é o default do Madamy. EN só quando STORE_LOCALE=en. */

const PT = {
  gifAlt: "Sua Personal Shopper",
  titleBefore: "Sua",
  titleAccent: "Personal Shopper",
  tagline: "Luxo, curadoria e exclusividade ao seu alcance.",
  emailLabel: "Email de acesso",
  emailPlaceholder: "seu@email.com",
  emailRequired: "Informe seu email",
  emailInvalid: "Email inválido",
  keepLogged: "Manter-me conectada",
  session30: "Sessão de 30 dias",
  session1: "Sessão de 1 dia",
  loading: "Carregando...",
  enter: "Entrar",
  noAccount: "Ainda não tem conta?",
  registerHere: "Cadastre-se aqui",
  footer: "Madamy Closet — Personal Shopper de Luxo",
  back: "Voltar",
  emailTakenTitle: "Este email já está cadastrado",
  emailTakenBody: "Parece que você já tem uma conta conosco. Faça login para acessar o clube VIP.",
  goLogin: "Ir para o Login",
  referred: "Você foi indicada por uma amiga! Ganhe bônus extra ao se cadastrar.",
  bannerTitle: "Acesse nossas",
  bannerAccent: "promoções exclusivas",
  bannerSub: "Preencha o formulário e ganhe acesso ao nosso clube VIP.",
  formTitle: "Queremos saber mais de você",
  nameLabel: "Qual seu nome?",
  namePlaceholder: "Nome completo",
  contact: "contato",
  whatsapp: "WhatsApp",
  ddd: "DDD",
  phonePlaceholder: "Seu número",
  instaLabel: "@ do seu Instagram",
  instaPlaceholder: "@seuinsta",
  prefs: "preferências",
  brandsLabel: "3 marcas que você mais ama",
  selected: "Selecionadas",
  brandsMin: "Por favor, selecione pelo menos 3 marcas.",
  bagLabel: "Já tem alguma bolsa de griffe?",
  bagNone: "Ainda não",
  bagOne: "Tenho uma",
  bagMany: "Tenho várias, amo!",
  birthday: "Seu aniversário (adoramos presentear)",
  datePlaceholder: "DD/MM/AAAA",
  gender: "Gênero",
  female: "Feminino",
  male: "Masculino",
  promoLabel: "Quais produtos você quer na promo?",
  promoPlaceholder: "Bolsas, sapatos, acessórios...",
  submit: "Quero Acesso VIP",
  registerOk: "Registro realizado com sucesso!",
  registerFail: "Erro ao realizar cadastro. Tente novamente.",
  needsRegister: "Esse e-mail veio da landing. Completa o cadastro pra entrar no app.",
};

const EN = {
  gifAlt: "Your Personal Shopper",
  titleBefore: "Your",
  titleAccent: "Personal Shopper",
  tagline: "Luxury, curation and exclusivity — within reach.",
  emailLabel: "Access email",
  emailPlaceholder: "you@email.com",
  emailRequired: "Enter your email",
  emailInvalid: "Invalid email",
  keepLogged: "Keep me signed in",
  session30: "30-day session",
  session1: "1-day session",
  loading: "Loading...",
  enter: "Sign in",
  noAccount: "Don't have an account?",
  registerHere: "Register here",
  footer: "Madamy Closet — Luxury Personal Shopper",
  back: "Back",
  emailTakenTitle: "This email is already registered",
  emailTakenBody: "You already have an account. Sign in to access the VIP club.",
  goLogin: "Go to Sign in",
  referred: "A friend referred you! Get an extra bonus when you register.",
  bannerTitle: "Access our",
  bannerAccent: "exclusive promotions",
  bannerSub: "Fill in the form and get access to our VIP club.",
  formTitle: "We want to know more about you",
  nameLabel: "What's your name?",
  namePlaceholder: "Full name",
  contact: "contact",
  whatsapp: "WhatsApp",
  ddd: "Area code",
  phonePlaceholder: "Your number",
  instaLabel: "Your Instagram @",
  instaPlaceholder: "@yourhandle",
  prefs: "preferences",
  brandsLabel: "3 brands you love most",
  selected: "Selected",
  brandsMin: "Please select at least 3 brands.",
  bagLabel: "Do you already own a designer bag?",
  bagNone: "Not yet",
  bagOne: "I have one",
  bagMany: "I have several — I love them!",
  birthday: "Your birthday (we love gifting)",
  datePlaceholder: "DD/MM/YYYY",
  gender: "Gender",
  female: "Female",
  male: "Male",
  promoLabel: "What products do you want on promo?",
  promoPlaceholder: "Bags, shoes, accessories...",
  submit: "I want VIP access",
  registerOk: "Registration successful!",
  registerFail: "Could not register. Please try again.",
  needsRegister: "This email came from the landing page. Complete registration to enter the app.",
};

const ES = {
  gifAlt: "Tu Personal Shopper",
  titleBefore: "Tu",
  titleAccent: "Personal Shopper",
  tagline: "Lujo, curaduría y exclusividad — a tu alcance.",
  emailLabel: "Email de acceso",
  emailPlaceholder: "tu@email.com",
  emailRequired: "Ingresa tu email",
  emailInvalid: "Email inválido",
  keepLogged: "Mantener sesión",
  session30: "Sesión de 30 días",
  session1: "Sesión de 1 día",
  loading: "Cargando...",
  enter: "Entrar",
  noAccount: "¿Aún no tienes cuenta?",
  registerHere: "Regístrate aquí",
  footer: "Madamy Closet — Personal Shopper de Lujo",
  back: "Volver",
  emailTakenTitle: "Este email ya está registrado",
  emailTakenBody: "Ya tienes una cuenta. Entra para acceder al club VIP.",
  goLogin: "Ir a Entrar",
  referred: "¡Una amiga te recomendó! Gana un bono extra al registrarte.",
  bannerTitle: "Accede a nuestras",
  bannerAccent: "promociones exclusivas",
  bannerSub: "Completa el formulario y entra al club VIP.",
  formTitle: "Queremos saber más de ti",
  nameLabel: "¿Cómo te llamas?",
  namePlaceholder: "Nombre completo",
  contact: "contacto",
  whatsapp: "WhatsApp",
  ddd: "Código",
  phonePlaceholder: "Tu número",
  instaLabel: "Tu Instagram @",
  instaPlaceholder: "@tuusuario",
  prefs: "preferencias",
  brandsLabel: "3 marcas que más amas",
  selected: "Elegidas",
  brandsMin: "Elige al menos 3 marcas.",
  bagLabel: "¿Ya tienes alguna bolsa de diseñador?",
  bagNone: "Todavía no",
  bagOne: "Tengo una",
  bagMany: "Tengo varias — ¡me encantan!",
  birthday: "Tu cumpleaños (nos encanta regalar)",
  datePlaceholder: "DD/MM/AAAA",
  gender: "Género",
  female: "Femenino",
  male: "Masculino",
  promoLabel: "¿Qué productos quieres en promo?",
  promoPlaceholder: "Bolsos, zapatos, accesorios...",
  submit: "Quiero acceso VIP",
  registerOk: "Registro listo!",
  registerFail: "No se pudo registrar. Intenta de nuevo.",
  needsRegister: "Este email vino de la landing. Completa el registro para entrar a la app.",
};

const RU = {
  gifAlt: "Ваш Personal Shopper",
  titleBefore: "Ваш",
  titleAccent: "Personal Shopper",
  tagline: "Роскошь, кураторство и эксклюзив — рядом.",
  emailLabel: "Email для входа",
  emailPlaceholder: "you@email.com",
  emailRequired: "Введите email",
  emailInvalid: "Неверный email",
  keepLogged: "Оставаться в системе",
  session30: "Сессия на 30 дней",
  session1: "Сессия на 1 день",
  loading: "Загрузка...",
  enter: "Войти",
  noAccount: "Еще нет аккаунта?",
  registerHere: "Зарегистрироваться",
  footer: "Madamy Closet — люксовый Personal Shopper",
  back: "Назад",
  emailTakenTitle: "Этот email уже зарегистрирован",
  emailTakenBody: "У вас уже есть аккаунт. Войдите в VIP-клуб.",
  goLogin: "Ко входу",
  referred: "Вас пригласила подруга! Бонус при регистрации.",
  bannerTitle: "Откройте наши",
  bannerAccent: "эксклюзивные акции",
  bannerSub: "Заполните форму и войдите в VIP-клуб.",
  formTitle: "Хотим узнать вас лучше",
  nameLabel: "Как вас зовут?",
  namePlaceholder: "Полное имя",
  contact: "контакты",
  whatsapp: "WhatsApp",
  ddd: "Код",
  phonePlaceholder: "Ваш номер",
  instaLabel: "Ваш Instagram @",
  instaPlaceholder: "@username",
  prefs: "предпочтения",
  brandsLabel: "3 любимых бренда",
  selected: "Выбрано",
  brandsMin: "Выберите минимум 3 бренда.",
  bagLabel: "Уже есть дизайнерская сумка?",
  bagNone: "Пока нет",
  bagOne: "Есть одна",
  bagMany: "Несколько — обожаю!",
  birthday: "День рождения (любим дарить)",
  datePlaceholder: "ДД/ММ/ГГГГ",
  gender: "Пол",
  female: "Женский",
  male: "Мужской",
  promoLabel: "Что хотите в промо?",
  promoPlaceholder: "Сумки, обувь, аксессуары...",
  submit: "Хочу VIP-доступ",
  registerOk: "Регистрация прошла!",
  registerFail: "Не удалось зарегистрироваться. Попробуйте снова.",
  needsRegister: "Этот email пришёл с лендинга. Завершите регистрацию, чтобы войти в приложение.",
};

export function authCopy(locale) {
  if (locale === "en") return EN;
  if (locale === "es") return ES;
  if (locale === "ru") return RU;
  return PT;
}
